
  import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';

  export default {
    name: 'FiveStarProductsCardV2',
    
    mixins: [eventTrackingMixins],

    props: {
      data: {
        type: Object,
        default: () => ({
        }),
      },
    },
    data() {
      return { 
        activeItemId: 0,
        showButton: false,
      }
    },
    computed: {
      badgeBackgroundImage () {
        const bgImage = require(`@/assets/images/products/icon-5-stars.png`)
        return `background-image: url( ${bgImage} ); `;
      }
    },
    methods: {
      
      onClickInternalLink(link, data, placement ) {
        this.$router.push(this.localePath(link))
      },
      toggleActiveItem(i) {
        if (i === this.activeItemId) {
          this.activeItemId = -1
        } else {
          this.setActiveItem(i)
        }
      },
  
      setActiveItem(i) {
        this.activeItemId = i
      },

    },
  }
  